import numbro from 'numbro';

import { enUsLocaleData } from './enUsLocale';

export const enGbLocaleData: numbro.NumbroLanguage = {
  ...enUsLocaleData,
  languageTag: 'en-GB',
  currency: {
    symbol: '£',
    position: 'prefix',
    code: 'GBP',
  },
};
